const CommentsIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6666 9.33331H11C11.5513 9.33331 12 8.88465 12 8.33331V2.33331C12 1.78198 11.5513 1.33331 11 1.33331H2.33331C1.78198 1.33331 1.33331 1.78198 1.33331 2.33331V12L4.88865 9.33331H10.6666ZM4.44465 7.99998L2.66665 9.33331V2.66665H10.6666V7.99998H4.44465Z"
      fill="currentColor"
    />
    <path
      d="M13.6666 5.33331H13.3333V9.33398C13.3333 10.0673 12.738 10.6626 12.0066 10.6666H5.33331V11C5.33331 11.5513 5.78198 12 6.33331 12H11.1113L14.6666 14.6666V6.33331C14.6666 5.78198 14.218 5.33331 13.6666 5.33331Z"
      fill="currentColor"
    />
  </svg>
);

export default CommentsIcon;
